/* eslint-disable max-len */
const projects = [
    {
        id: "00000",
        name: "Шаблон сайта-портфолио.",
        author: "Илья Росчихмаров",
        date: "07.02.2022",
        description:
            "Полностью готовый сайт для создания идеального портфолио, просто добавьте нужный контент и готово! Сайт использует систему управления статическим сайтом Textolite, благодаря которой вы с лёгкостью сможете менять и дополнять текст и изображения.",
        skills: ["HTML", "CSS (SCSS)", "JavaScript", "Gulp", "Textolite", "PHP"],
        socials: {
            github: "https://github.com/ilrosch/ilrosch.github.io",
            telegram: "https://t.me/ilrosch",
        },
        demo: "https://ilrosch.github.io",
        image: "https://cdn-edge.kwork.ru/pics/t3/23/19582966-1648055628.webp",
    },

    {
        id: "00001",
        name: "Саровpi",
        author: "Илья Росчихмаров",
        date: "15.10.2021",
        description:
            "Саровpi – новый проект, который показывает, как меняется жизнь, обстановка в городе, благодаря новшествам и облагораживанию территории. С каждым годом в нашем городе реализуются все больше проектов, которые идут на благо людям. Здесь вы найдете краткую информацию о некоторых проектах, которые реализуются или уже были реализованы в Сарове.",
        skills: ["HTML", "CSS (SCSS)", "JavaScript", "Gulp", "PHP"],
        socials: {
            github: "https://github.com/ilrosch/sarovpi",
            telegram: "https://t.me/ilrosch",
        },
        demo: "https://ilrosch.github.io/sarovpi",
        image: "https://cdn-edge.kwork.ru/files/portfolio/t3/09/960c3e66de701a5045f2c2d1dd58f1c218fb37f0-1661517609.webp",
    },

    {
        id: "00004",
        name: "AMV",
        author: "Заур Нурмагомедов",
        date: "30.04.2022",
        description:
            "Суть данного сайта заключается в том, чтобы объединить ценителей AMV-роликов в одну социальную сеть. На данный момент, я не встретил аналогов на просторах интернета. И, так как я вовлечен в данное творение Минервы, я решил стать организатором сообщества, быть может, глобального уровня xD. Здесь каждый сможет выложить свою работу, каждый будет способен увидеть твое творчество, оценить его. Веб-сайт находится только на стадии разработки, он подготовлен для мобильных приложений. Как будет время, он засияет новым светом. Подробное описание в ридми файле репозитория.",
        skills: ["HTML", "SCSS", "JavaScript", "Python (Flask)", "RestAPI", "SQLite3"],
        socials: {
            github: "https://github.com/mrSkyGuy/amv.net",
            telegram: "https://t.me/skyguy",
        },
        demo: "https://github.com/mrSkyGuy/amv.net",
        image: "https://raw.githubusercontent.com/ilrosch/dream-team/development/src/img/projects/zaur_nurmagomedov/amv.jpg",
    },

    {
        id: "00005",
        name: "Aiogram_captcha",
        author: "Заур Нурмагомедов",
        date: "04.07.2022",
        description:
            "Капча для бота на aiogram. Довольно сырой вариант. В будущем будет дорабатываться.",
        skills: ["Python (aiogram)"],
        socials: {
            github: "https://github.com/mrSkyGuy/aiogram_captcha",
            telegram: "https://t.me/skyguy",
        },
        demo: "https://github.com/mrSkyGuy/aiogram_captcha",
        image: "https://raw.githubusercontent.com/ilrosch/dream-team/development/src/img/projects/zaur_nurmagomedov/aiogram_captcha.jpg",
    },

    {
        id: "00006",
        name: "Сайт-визитка skyResume",
        author: "Заур Нурмагомедов",
        date: "09.10.2022",
        description:
            "Сайт-визитка, в кратце описал свой опыт в разработке.",
        skills: ["JavaScript", "React", "SCSS", "MUI"],
        socials: {
            github: "https://github.com/mrSkyGuy/skyResume",
            telegram: "https://t.me/skyguy",
        },
        demo: "https://github.com/mrSkyGuy/skyResume",
        image: "https://raw.githubusercontent.com/ilrosch/dream-team/development/src/img/projects/zaur_nurmagomedov/skyResume.jpg",
    },

    {
        id: "00007",
        name: "App-for-LearningWords",
        author: "Заур Нурмагомедов",
        date: "20.10.2021",
        description:
            "Десктопное приложение для изучения новых слов как русских, так и иностранных. На выбор имеется 4 курса: русский -медицинский, английский -сленг, испанский -база, собственный (список будет расширяться). Их можно выбрать несколько штук на изучение. В дальнейшем планируется переписать на нормальный ЯП и расширить возможности. Подробнейшая инструкция указана в ридми файле репозитория.",
        skills: ["Python (PyQt5, BeautifulSoup4)", "SQLite3"],
        socials: {
            github: "https://github.com/mrSkyGuy/App-for-LearningWords",
            telegram: "https://t.me/skyguy",
        },
        demo: "https://github.com/mrSkyGuy/App-for-LearningWords",
        image: "https://raw.githubusercontent.com/ilrosch/dream-team/development/src/img/projects/zaur_nurmagomedov/App-for-LearningWords.jpg",
    },

    {
        id: "00008",
        name: "Inline buttons list view",
        author: "Заур Нурмагомедов",
        date: "25.06.2022",
        description:
            "Реализация пагинации контента через инлайн-кнопки в боте. Выполнялся совместно с другом в его репозитории",
        skills: ["Python (aiogram)"],
        socials: {
            github: "https://github.com/mrSkyGuy/",
            telegram: "https://t.me/skyguy",
        },
        demo: "https://github.com/platon-p/aiogram_list_view",
        image: "https://raw.githubusercontent.com/ilrosch/dream-team/development/src/img/projects/zaur_nurmagomedov/Inline-buttons-list-view.jpg",
    },
];

export default projects;
